<template>
  <div class="tags">
    <div class="head-box" style="border-bottom:none">
      <h4>标签管理</h4>
      <div class="c-flex">
        <el-button type="primary" @click="doNew()" class="c-m-l-10">新建标签分组</el-button>
      </div>
    </div>
    <div class="content-box">
      <el-tabs v-model="target" type="card" class="c_w" @tab-click="targetChange">
        <el-tab-pane
          v-for="item in options.target"
          :key="item.value"
          :label="item.label"
          :name="item.value"
        >
          <el-table
            v-if="target == item.value"
            :ref="target + 'Table'"
            height="calc(100vh - 174px)"
            :data="tagTypeData"
            highlight-current-row
          >
            <el-table-column
              label="分组名称"
              prop="name"
              width="150px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="适用角色" width="80px" show-overflow-tooltip>
              <template slot-scope="scope">
                <span v-if="scope.row.type == 0">
                  {{ osg.codelabel('tagRole', scope.row.typeId) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="标签">
              <template slot-scope="scope">
                <div class="c-flex c-flex-wrap" style="gap:10px">
                  <template v-for="item in tagData">
                    <div v-if="scope.row._id == item.tagTypeId" :key="item._id">
                      <el-tag size="medium">
                        {{ item.name }}
                      </el-tag>
                    </div>
                  </template>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="80px">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.state == 1" type="success" effect="dark" size="medium">
                  已启用
                </el-tag>
                <el-tag v-else-if="scope.row.state == 0" type="danger" effect="dark" size="medium">
                  已禁用
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column fixed="right" width="100px">
              <template slot-scope="scope">
                <el-dropdown>
                  <el-button>
                    操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="doEdit(scope.row)">
                      编辑
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="scope.row.state == 0"
                      @click.native="doEnable(scope.row._id)"
                    >
                      启用
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="scope.row.state == 1"
                      @click.native="doDisable(scope.row._id)"
                    >
                      禁用
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="doRemove(scope.row._id)">
                      删除
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 标签组弹框 -->
    <el-dialog title="标签管理" :close-on-click-modal="false" :visible.sync="openDetail">
      <el-form ref="formData" :model="formData" label-width="100px" label-position="left">
        <el-form-item v-if="!formData._id" label="业务对象" prop="target">
          <el-select v-model="formData.target" disabled>
            <template v-for="item in options.target">
              <el-option :key="item.value" :label="item.label" :value="item.value"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          label="分组名称"
          prop="name"
          :rules="{
            required: true,
            trigger: 'change',
            message: '分组名称不能为空'
          }"
        >
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item
          v-if="!formData._id"
          label="适用角色"
          prop="typeId"
          :rules="{
            required: tagTypeData.find(item => item.type == 1) ? true : false,
            trigger: 'change',
            message: '适用角色不能为空'
          }"
        >
          <el-select v-model="formData.typeId" clearable placeholder="自定义分组时为空">
            <template v-for="item in options.tagRole">
              <el-option :key="item.value" :label="item.label" :value="item.value"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item v-if="formData._id" label="标签" label-position="top">
          <div v-for="(item, i) in formData.tags" :key="i" class="c_flex c_item_center c-m-b-10">
            <el-input v-model.trim="item.name" class="c_flex_1" @blur="saveTag(item, i)"></el-input>
            <i
              class="el-icon-remove c_red c_size_18 c-center pointer"
              style="width:10%"
              @click="removeTag(item, i)"
            ></i>
          </div>
          <el-button plain icon="el-icon-plus" class="button_dashed" @click="addTag">
            新增标签
          </el-button>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'Tags',
  data() {
    window.$this = this;
    return {
      name: 'tags',
      target: 'serviceAppointment',
      tagTypeData: [],
      tagData: [],
      openDetail: false,
      formData: {
        tags: []
      },
      options: {
        codecfg_target: { codeId: 'target' },
        codecfg_tagRole: { codeId: 'tagRole' }
      },
      userId: ''
    };
  },
  mounted() {
    this.userId = JSON.parse(sessionStorage['loginAccount'])._id;
    this.osg.codeoption(() => {
      this.getTagTypeData(() => {
        this.getTagData();
      });
    });
  },
  methods: {
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        target: this.target
      };
    },
    targetChange() {
      this.getTagTypeData(() => {
        this.getTagData();
      });
    },
    getTagTypeData(callback) {
      this.osg.ajax(
        'basic/tagType/query.do',
        {
          _all: '1',
          'in:state|array-integer#and': '0,1',
          'is:target|string#and': this.target,
          sortField: 'type',
          sortOrder: 'asc'
        },
        res => {
          this.tagTypeData = res.data;
          if (callback) callback();
          this.$nextTick(() => {
            this.$refs[this.target + 'Table'] &&
              this.$refs[this.target + 'Table'][0] &&
              this.$refs[this.target + 'Table'][0].doLayout();
            this.$forceUpdate();
          });
        },
        { noload: true }
      );
    },
    getTagData() {
      this.osg.ajax(
        'basic/tag/query.do',
        {
          _all: '1',
          'in:state|array-integer#and': '0,1',
          'in:tagTypeId|array#and': this.tagTypeData.map(item => item._id).join()
        },
        res => {
          this.tagData = res.data;
        },
        { noload: true }
      );
    },
    getSubTagData() {
      this.osg.ajax(
        'basic/tag/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'in:tagTypeId|array#and': this.formData._id
        },
        res => {
          this.$set(this.formData, 'tags', res.data);
        },
        { noload: true }
      );
    },
    doEdit(row) {
      this.formData = this.$util.deepCopy(row);
      this.getSubTagData();
      this.openDetail = true;
    },
    addTag() {
      this.formData.tags.push({
        name: '',
        tagTypeId: this.formData._id,
        type: this.formData.type,
        typeId: this.formData.type == 0 ? this.formData.typeId : this.userId
      });
    },
    saveTag(item, i) {
      if (item.name) {
        this.osg.ajax(
          'basic/tag/upsert.do',
          { data: JSON.stringify(item) },
          res => {
            this.$set(this.formData.tags, i, res.data);
            this.getTagData();
          },
          {
            noload: true,
            fail: () => {
              item.name = '';
            }
          }
        );
      }
    },
    removeTag(item, i) {
      if (!item._id) {
        this.formData.tags.splice(i, 1);
      } else {
        this.osg.confirm('删除后，已添加到客户信息的标签将无法显示。', () => {
          this.osg.ajax(
            `basic/tag/remove/${item._id}.do`,
            {},
            () => {
              this.formData.tags.splice(i, 1);
              this.getTagData();
            },
            { noload: true }
          );
        });
      }
    },
    doEnable(id) {
      this.osg.ajax(`basic/tagType/enable/${id}.do`, {}, () => {
        this.getTagTypeData(() => {
          this.getTagData();
        });
        this.osg.toast('启用成功');
      });
    },
    doDisable(id) {
      this.osg.ajax(`basic/tagType/disable/${id}.do`, {}, () => {
        this.getTagTypeData(() => {
          this.getTagData();
        });
        this.osg.toast('禁用成功');
      });
    },
    doRemove(id) {
      this.osg.confirm('删除标签分组，分组下的标签也将一起删除。', () => {
        this.osg.ajax(`basic/tagType/remove/${id}.do`, {}, () => {
          this.getTagTypeData(() => {
            this.getTagData();
          });
          this.osg.toast('删除成功');
        });
      });
    },
    doSave() {
      if (this.osg.validate()) {
        let params = this.$util.deepCopy(this.formData); // 直接操作this.formData，在tagSave没执行完时删除tags字段会报错。
        delete params.tags;
        params.type = params.typeId ? 0 : 1; // type 0:角色 1:自定义
        this.osg.ajax(
          'basic/tagType/upsert.do',
          { data: JSON.stringify(params) },
          () => {
            this.openDetail = false;
            this.getTagTypeData();
            this.osg.toast('保存成功！');
          },
          { noload: true }
        );
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.tags {
  overflow-y: hidden;
}
</style>
